import React from "react";
import styled from "styled-components";
import { useUserSettings } from "components/Site/Contexts/UserSettings";
import LoadingIcon from "icons/LoadingIcon";

interface LoaderProps {
  size?: number;
  color?: string;
  style?: object;
}

const LoadingContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

export default function Loader({ size = 128, color, style }: LoaderProps) {
  const { darkMode } = useUserSettings();
  const fillColor = color || darkMode ? "#666" : "#e8e8e8";

  return (
    <LoadingContainer style={style}>
      <LoadingIcon size={size} color={fillColor} />
    </LoadingContainer>
  );
}
